// Use window.axios to ensure auth interceptors are applied
export default class AxiosFunction {

    static axiosGet(url, data = null) {
        return data ? window.axios.get(url, data) : window.axios.get(url);
    }

    static axiosPost(options) {
        return window.axios.post(options.url, options.data);
    }

    static axiosUploadPost(options, callback) {
        return window.axios.post(options.url, options.data, {
            onUploadProgress: callback
          });
    }

    static axiosPut(options) {
        return window.axios.put(options.url, options.data);
    }

    static axiosDelete(url) {
        return window.axios.delete(url);
    }

    static axiosPatch(options) {
        return window.axios.patch(options.url, options.data);
    }

    static responseToCallback(promise, succesCallback, errorCallback) {
        promise.then(response => {
            if (succesCallback) succesCallback(true, response.data); //returns success response data
        }).catch(({ response }) => {
            if (errorCallback) errorCallback(false, response.data); //returns error response data
        });
    }
}